import collaboratorsApi from 'api/requests/collaborators';
import Text from 'components/_UI/Text';
import Loader from 'components/_UI/Loader';
import EventCard from 'modules/dashboard/profile/items/card/EventCard';
import Checkin from 'modules/dashboard/checkin/Checkin';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import CollaboratorEventDetail from './CollaboratorEventDetail';

const PANEL_PERMISSIONS = ['event.edit', 'event.sales.view'];

/**
 * Tela de quem foi convidado como colaborador de evento(s) — substitui a
 * antiga tela solta de checkin (só validação + participantes). Além disso,
 * quando o produtor concedeu algo mais (event.edit / event.sales.view),
 * mostra também uma seção "Meus eventos" com o que foi liberado — sem
 * reaproveitar o painel completo do produtor, que exige papel próprio.
 */
export default function CollaboratorPanel() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState(null);

    useEffect(() => {
        getEvents();
    }, []);

    async function getEvents() {
        setLoading(true);

        try {
            const { data } = await collaboratorsApi.get();
            setEvents(data?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const managedEvents = events.filter(event => PANEL_PERMISSIONS.some(permission => event?.permissions?.includes(permission)));

    if (loading) {
        return (
            <FullyCentered height='200px'>
                <Loader />
            </FullyCentered>
        );
    }

    if (selectedEvent) {
        return (
            <CollaboratorEventDetail
                event={selectedEvent}
                onBack={() => setSelectedEvent(null)}
            />
        );
    }

    return (
        <Column>
            {
                !!managedEvents.length && (
                    <ManagedEventsSection>
                        <Text type='bold' color={colors.nightDark} marginBottom={'10px'}>
                            Meus eventos
                        </Text>

                        {
                            managedEvents.map(event => (
                                <EventCard
                                    key={event.slug}
                                    data={event}
                                    onClick={() => setSelectedEvent(event)}
                                />
                            ))
                        }
                    </ManagedEventsSection>
                )
            }

            <Checkin withParticipants />
        </Column>
    );
}

const ManagedEventsSection = styled(Column)`
    width: 100%;
    margin-bottom: 24px;
`;
